import { Web3ProviderInterface } from '../../types/web3';
import { createContext } from 'react';
import { EnvioGraphQLClient } from '@peeramid-labs/sdk';

export const Web3ProviderContext = createContext<Web3ProviderInterface>({
  logout: async () => {
    console.error('not initialized');
  },
  isLoggingOut: () => false,
  currentChain: undefined,
  account: undefined,
  isConnected: false,
  publicClient: undefined,
  walletClient: undefined,
  envioClient: new EnvioGraphQLClient(),
  isExternalWallet: false,
});

export default Web3ProviderContext;
